import api from './api';

export async function getApplicationDocs (appId) {
  const response = await api.request({
    method: 'get',
    url: '/app-portal/document/list/application',
    params: {
      appId
    }
  });

  return response.data;
};

export async function getUserDocs () {
  const response = await api.request({
    method: 'get',
    url: '/app-portal/document/list/user'
  });

  return response.data;
};

export async function deleteApplicationDoc (docId, appId) {
  const response = await api.request({
    method: 'delete',
    url: '/app-portal/document/delete/application',
    params: {
      docId,
      appId
    }
  });

  return response.data;
};

export async function uploadApplicationDoc (typeId, appId, file, attributes) {
  let formData = new FormData();

  formData.append('file', file);

  const response = await api.request({
    method: 'post',
    url: '/app-portal/document/upload/application',
    params: {
      typeId,
      appId,
      attributes: JSON.stringify(attributes)
    },
    data: formData
  });
  return response.data;
};

export async function uploadApplicationDocFileLink (typeId, appId, fileLink, attributes) {
  const response = await api.request({
    method: 'post',
    url: '/app-portal/document/file-link/application',
    params: {
      typeId,
      appId,
      fileLink,
      attributes: JSON.stringify(attributes)
    }
  });
  return response.data;
};


export async function uploadUserDoc (typeId, file, attributes) {
  let formData = new FormData();

  formData.append('file', file);

  const response = await api.request({
    method: 'post',
    url: '/app-portal/document/upload/user',
    params: {
      typeId,
      attributes: JSON.stringify(attributes)
    },
    data: formData
  });
  return response.data;
};
